import { svg, esc } from '../ui/icons.js';
import { competenciaExtenso } from '../lib/supabase.js';
import * as Cobranca from '../data/cobranca.js';
import { dados } from '../state.js';
import { usuario, ehGestao } from '../auth.js';

/**
 * "Quem ainda não mandou" — a lista de cobrança da competência.
 *
 * Sai do próprio painel: conta que segue faltante. Não lemos a caixa do
 * Titan. O sistema monta o texto do e-mail, a pessoa revisa e envia por
 * lá, e depois registra aqui que a cobrança saiu.
 *
 * Nada é enviado em nome de ninguém — o botão copia o texto, não dispara
 * e-mail.
 */

let competencia = null;
let aoMudarDados = () => {};

export function configurar({ onChange }) {
  aoMudarDados = onChange || (() => {});
  document.getElementById('cobCompetencia')?.addEventListener('change', (ev) => {
    competencia = ev.target.value ? ev.target.value + '-01' : null;
    render();
  });
}

function competenciaPadrao() {
  // O mês anterior é o que se cobra: o corrente ainda está acontecendo.
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function montarSeletor() {
  const sel = document.getElementById('cobCompetencia');
  if (!sel || sel.value) return;
  sel.value = competenciaPadrao();
  competencia = sel.value + '-01';
}

export async function render() {
  const alvo = document.getElementById('cobWrap');
  if (!alvo) return;

  if (!competencia) montarSeletor();
  if (!competencia) return;

  alvo.innerHTML = '<p class="ind-carregando">Verificando quem ainda não mandou…</p>';

  try {
    const linhas = await Cobranca.pendentes(competencia);

    if (!linhas.length) {
      alvo.innerHTML = `
        <div class="cob-vazio">
          ${svg('check', 18)}
          <span>Ninguém devendo em <b>${competenciaExtenso(competencia)}</b> — todos os extratos chegaram.</span>
        </div>`;
      return;
    }

    const totalContas = linhas.reduce((n, l) => n + l.contas_faltantes, 0);
    const jaCobradas = linhas.filter((l) => l.cobrancas_no_mes > 0).length;

    alvo.innerHTML = `
      <div class="cob-resumo">
        <span class="doc-origem pdf">${linhas.length} empresa(s) devendo</span>
        <span class="doc-origem pdf">${totalContas} conta(s) sem extrato</span>
        ${jaCobradas ? `<span class="cob-ja">${jaCobradas} já cobrada(s) nesta competência</span>` : ''}
      </div>

      <div class="table-wrap">
        <table class="config-tabela cob-tabela">
          <thead>
            <tr>
              <th>Empresa</th><th>Contas faltando</th><th>Responsável</th>
              <th>Cobranças</th><th></th>
            </tr>
          </thead>
          <tbody>
            ${linhas.map((l) => `
              <tr data-empresa="${l.empresa_id}">
                <td>
                  <b>${esc(l.empresa_nome)}</b>
                  <div class="cob-email">${l.email ? esc(l.email) : '<span class="cob-sem-email">sem e-mail cadastrado</span>'}</div>
                </td>
                <td>
                  <span class="tag red">${l.contas_faltantes} de ${l.contas_total}</span>
                  <div class="cob-contas">${esc(l.contas_nomes || '—')}</div>
                </td>
                <td>${esc(l.responsaveis || '—')}</td>
                <td>
                  ${l.cobrancas_no_mes
                    ? `<span class="tag amber">${l.cobrancas_no_mes}x nesta competência</span>`
                    : '<span class="cob-nunca">ainda não cobrada</span>'}
                  ${l.dias_sem_cobrar != null
                    ? `<div class="cob-dias">última há ${l.dias_sem_cobrar} dia(s)</div>` : ''}
                </td>
                <td style="text-align:right;white-space:nowrap;">
                  <button class="btn cob-copiar" type="button">Copiar texto</button>
                  <button class="btn primary cob-registrar" type="button">Registrar cobrança</button>
                </td>
              </tr>`).join('')}
          </tbody>
        </table>
      </div>

      <p class="ind-nota">
        ${svg('alert', 13)}
        <span>O sistema <b>não envia e-mail</b>. "Copiar texto" põe a mensagem na área de
        transferência para você colar no Titan; "Registrar cobrança" anota que ela saiu,
        para o histórico responder depois quantas vezes o cliente foi cobrado.</span>
      </p>`;

    ligar(linhas);
  } catch (err) {
    alvo.innerHTML = `<p class="ind-erro">Não foi possível carregar: ${esc(err.message)}</p>`;
  }
}

function ligar(linhas) {
  const porId = new Map(linhas.map((l) => [l.empresa_id, l]));

  document.querySelectorAll('.cob-copiar').forEach((btn) =>
    btn.addEventListener('click', async () => {
      const id = btn.closest('tr').dataset.empresa;
      const texto = Cobranca.montarTexto(porId.get(id), competencia);
      try {
        await navigator.clipboard.writeText(texto);
        const antes = btn.textContent;
        btn.textContent = 'Copiado';
        setTimeout(() => { btn.textContent = antes; }, 1800);
      } catch {
        // Sem permissão de área de transferência: mostra para copiar na mão.
        prompt('Copie o texto abaixo:', texto);
      }
    })
  );

  document.querySelectorAll('.cob-registrar').forEach((btn) =>
    btn.addEventListener('click', async () => {
      const id = btn.closest('tr').dataset.empresa;
      const l = porId.get(id);
      if (!confirm(`Registrar que ${l.empresa_nome} foi cobrada sobre ${competenciaExtenso(competencia)}?`)) return;

      btn.disabled = true;
      try {
        await Cobranca.registrar({
          empresaId: id,
          competencia,
          faltantes: l.contas_faltantes,
        });
        await render();
        aoMudarDados();
      } catch (err) {
        btn.disabled = false;
        alert('Não foi possível registrar: ' + err.message);
      }
    })
  );
}
